import React from 'react';

interface PaymentGatewayProps {
  configValues: Record<string, string>;
  onChange: (key: string, val: string) => void;
  onSave: () => void;
  saving?: boolean;
  loading?: boolean;
  readOnly?: boolean;
}

const PaymentGateway: React.FC<PaymentGatewayProps> = ({ configValues, onChange, onSave, saving, loading, readOnly }) => {
  const cardStyle: React.CSSProperties = {
    background: "hsl(var(--card))",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid hsl(var(--border))",
  };

  const cardTitleStyle: React.CSSProperties = {
    margin: 0,
    fontSize: "16px",
    fontWeight: "700",
    color: "hsl(var(--foreground))"
  };

  const inputStyle: React.CSSProperties = {
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid hsl(var(--border))",
    outline: "none",
    fontSize: "14px",
    background: "hsl(var(--card))",
    color: "hsl(var(--foreground))",
    width: "100%",
    boxSizing: "border-box"
  };

  const labelStyle: React.CSSProperties = {
    fontSize: "13px",
    fontWeight: "600",
    color: "hsl(var(--muted-foreground))",
    marginBottom: "8px",
    display: "block"
  };

  return (
    <div style={cardStyle}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "24px" }}>
        <h3 style={cardTitleStyle}>Payment Gateway Settings</h3>
        {!readOnly && (
          <button style={{ color: "hsl(var(--primary))", background: "none", border: "none", fontSize: "13px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}>
             Test Connection
          </button>
        )}
      </div>

      {loading ? (
        <div style={{ color: 'hsl(var(--muted-foreground))', fontSize: 14 }}>Loading configuration...</div>
      ) : (
        <>
          {/* Provider Status Card */}
          <div style={{ border: "1px solid hsl(var(--border))", background: "hsl(var(--muted)/0.3)", padding: "16px", borderRadius: "12px", marginBottom: "24px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "32px", height: "32px", background: "hsl(var(--card))", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid hsl(var(--border))", fontSize: "10px", fontWeight: "bold", color: "#2563eb" }}>RZP</div>
                <div>
                  <div style={{ fontWeight: "600", fontSize: "14px", color: "hsl(var(--foreground))" }}>Razorpay Payment Gateway</div>
                  <div style={{ fontSize: "12px", color: "hsl(var(--muted-foreground))" }}>Primary payment processor</div>
                </div>
              </div>
              <span style={{ fontSize: "11px", background: "hsl(162,72%,47%, 0.1)", color: "hsl(162,72%,47%)", padding: "4px 10px", borderRadius: "10px", fontWeight: "700" }}>Active</span>
            </div>
          </div>

          {/* API Keys Row */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "24px" }}>
            <div>
              <label style={labelStyle}>Razorpay Key ID</label>
              <input style={inputStyle} value={configValues['payment_razorpay_key_id'] || ''} onChange={e => onChange('payment_razorpay_key_id', e.target.value)} placeholder="rzp_live_..." disabled={readOnly} />
            </div>
            <div>
              <label style={labelStyle}>Razorpay Key Secret</label>
              <input style={inputStyle} type="password" value={configValues['payment_razorpay_key_secret'] || ''} onChange={e => onChange('payment_razorpay_key_secret', e.target.value)} placeholder="••••••••••••••••" disabled={readOnly} />
            </div>
          </div>

          {/* Webhook & Fees Row */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "24px" }}>
            <div>
              <label style={labelStyle}>Webhook Secret</label>
              <input style={inputStyle} value={configValues['payment_razorpay_webhook_secret'] || ''} onChange={e => onChange('payment_razorpay_webhook_secret', e.target.value)} placeholder="••••••••" disabled={readOnly} />
            </div>
            <div>
              <label style={labelStyle}>Processing Fee (%)</label>
              <input style={inputStyle} value={configValues['payment_razorpay_fee_percentage'] || ''} onChange={e => onChange('payment_razorpay_fee_percentage', e.target.value)} placeholder="2.0" disabled={readOnly} />
            </div>
          </div>

          {/* Payout Schedule Row */}
          <div style={{ marginBottom: "24px" }}>
            <label style={labelStyle}>Payout Schedule</label>
            <select style={{ ...inputStyle, appearance: "none", cursor: readOnly ? "default" : "pointer" }} value={configValues['payment_schedule'] || 'Manual'} onChange={e => onChange('payment_schedule', e.target.value)} disabled={readOnly}>
              <option value="Daily (automatic)">Daily (automatic)</option>
              <option value="Weekly (automatic)">Weekly (automatic)</option>
              <option value="Manual">Manual</option>
            </select>
          </div>

          {!readOnly && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button 
                onClick={onSave} 
                disabled={saving} 
                style={{ padding: "10px 20px", borderRadius: "10px", border: "none", background: "hsl(var(--primary))", color: "#fff", fontWeight: "600", cursor: "pointer" }}>
                {saving ? 'Saving...' : '✓ Save Settings'}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PaymentGateway;